<template>
  <div>

    <h2>Добро пожаловать в раздел лабораторных работ по физике!</h2>
    



  </div>
</template>




